import SectionMessage, {
  SectionMessageAction,
} from '@atlaskit/section-message';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';

import React from 'react';

const messages = defineMessages({
  description: {
    id: 'auth-section-description',
    defaultMessage:
      "We've changed how permissions work, so apps can now request only the information they need.",
    description: 'Description for oauth explanation of permissions change',
  },
  learnMore: {
    id: 'auth-section-learn-more',
    defaultMessage: 'Learn more',
    description: 'Link to learn more about oauth',
  },
  title: {
    id: 'auth-section-title',
    defaultMessage: 'Apps are becoming more transparent',
    description: 'Title for the auth section message',
  },
});

const AuthMessage: React.FC = () => {
  const { formatMessage } = useIntl();
  return (
    <SectionMessage
      title={formatMessage(messages.title)}
      actions={[
        <SectionMessageAction
          href="https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers"
          key={'test'}
        >
          {formatMessage(messages.learnMore)}
        </SectionMessageAction>,
      ]}
    >
      <FormattedMessage {...messages.description} tagName="p" />
    </SectionMessage>
  );
};

export default AuthMessage;
